import React, { useEffect, useRef, useState } from "react";
import styles from "./inActiveOffer.module.scss";
import { Add, Numbers, UploadFile } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/customComponents/customButton/CustomButton";
import { GenCustomTable } from "../../components/customComponents/genCustomTable/GenCustomTable";
import {
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Dialog,
  DialogTitle,
  DialogContent,
  Box
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import SearchInput from "../../components/uiComponents/searchInput/SearchInput";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import OutlinedButton from "../../components/customComponents/outlinedButton/OutlinedButton";
import { connect, useDispatch } from "react-redux";
import { getAllCategory, getAllOffer, getAllProduct, getOfferByIdResponse } from "../../store/actions";
import EditIcon from "@mui/icons-material/Edit";
import { getObjectFromArrayOfObjects } from "../../utils/common/CommonFunctions";
const columns = [
  {
    id: 1,
    label: "S.NO",
    minWidth: 120,
    align: "center",
  },
  {
    id: 2,
    label: "offer ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 3,
    label: "Product ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 4,
    label: "Category ID",
    minWidth: 170,
    align: "center",
  },
  {
    id: 5,
    label: "Percentage",
    minWidth: 170,
    align: "center",
  },
  {
    id: 6,
    label: "Start Date",
    minWidth: 170,
    align: "center",
  },
  {
    id: 7,
    label: "End Date",
    minWidth: 170,
    align: "center",
  },
  {
    id: 8,
    label: "Action",
    minWidth: 170,
    align: "center",
  },
];

const InActiveOffer = ({ offers = [],  products = [], categories = [] }) => {
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);
  const [searched, setsearched] = useState([]);
  const [selected, setSelected] = useState(0);
  const [values, setValues] = useState({});
  const navigate = useNavigate();
  const [popupOpen, setPopupOpen] = useState(false);
  const [popupItems, setPopupItems] = useState([]);
  const [popupType, setPopupType] = useState("");

  useEffect(() => {
    dispatch(getAllOffer());
    dispatch(getAllProduct());
    dispatch(getAllCategory());
  }, []);

  const handleEdit = (item = {}) => {
    dispatch(getOfferByIdResponse(item));
    navigate("/editOffer", { state: "edit" });
  };

  const handleFilterStatus = () => {
    const filterData = offers?.filter((item) => item?.status === 0);
    return filterData;
  };
  const openProductPopUp = (productIds) => {
    const matchedProducts = productIds
      ?.map((productId) => getObjectFromArrayOfObjects(products, "id", productId)?.name)
      ?.filter(Boolean);
    setPopupItems(matchedProducts);
    setPopupType("product");
    setPopupOpen(true);
  };
  const openCategoryPopUp = (categoryIds) => {
    const matchedCategories = categoryIds
      ?.map((categoryId) => getObjectFromArrayOfObjects(categories, "id", categoryId)?.name)
      ?.filter(Boolean);
    setPopupItems(matchedCategories);
    setPopupType("category");
    setPopupOpen(true);
  };

  const closePopup = () => setPopupOpen(false);

  const getStructuredRows = (data = []) => {
    const structuredRows = data?.map((item, idx) => ({
      id: item?.id,
      rColumns: [
        idx + 1,
        item?.id,
        <>
          <Button
            variant="outlined"
            sx={{
              borderRadius: "999px",
              borderColor: "#1976d2",
              color: "#1976d2",
              textTransform: "none",
              padding: "2px 16px",
              fontSize: "0.875rem",
              minWidth: "unset",
            }}
            onClick={() => openProductPopUp(item?.productId)}
          >
            View
          </Button>
        </>,
        <>
          <Button
            variant="outlined"
            sx={{
              borderRadius: "999px",
              borderColor: "#1976d2",
              color: "#1976d2",
              textTransform: "none",
              padding: "2px 16px",
              fontSize: "0.875rem",
              minWidth: "unset",
            }}
            onClick={() => openCategoryPopUp(item?.categoryId)}
          >
            View
          </Button>
        </>,
        item?.percentage,
        item?.startDate,
        item?.endDate,
        <div className={styles.imgtable} onClick={() => handleEdit(item)}>
          <EditIcon color="primary" />
          EDIT
        </div>,
      ],
    }));

    return structuredRows;
  };
  const getData = (input, data) => {
    const dataFilter = data?.filter((item) =>
      item?.name?.toLowerCase().includes(input?.toLowerCase())
    );
    if (dataFilter?.length > 0) {
      setFilteredData(dataFilter);
    } else {
      setFilteredData(null);
    }
  };

  const handleSearch = (value) => {
    setsearched(value);
    console.log("ssss", value);
    if (value.length === 0) {
      setFilteredData([]);
    } else {
      // return getData(value, brand);
    }
  };

  const handleSaveChanges = () => { };

  const handleNavigate = () => {
    navigate("/editOffer");
  };

  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.topWrapper}>
          <div className={styles.top}></div>
          <div className={styles.search}>
            {/* <SearchInput />
            <Button
              variant="outlined"
              startIcon={<FilterAltOutlinedIcon />}
              className={styles.filterButton}
            >
              Filter
            </Button> */}
            <CustomButton
              title={"Add"}
              txtClr={"#FFFFFF"}
              background={"black"}
              width={"141px"}
              height={"48px"}
              borderRadius={"12px"}
              onClick={() => handleNavigate()}
            />
          </div>
        </div>
        <div className={styles.bottom}>
          <GenCustomTable columns={columns} rows={getStructuredRows(handleFilterStatus())} />
        </div>
      </div>
      <Dialog
        open={popupOpen}
        onClose={closePopup}
        maxWidth="sm"
        fullWidth
        hideBackdrop
        PaperProps={{
          sx: {
            borderRadius: "12px",
            padding: "16px",
            backgroundColor: "#fff",
            zIndex: 1301,
          },
        }}
        sx={{
          position: "absolute",
          top: "20%",
          left: "50%",
          transform: "translateX(-50%)",
        }}
      >
        <DialogTitle>
          {popupType === "product" ? "Products" : "Categories"}
          <IconButton
            onClick={closePopup}
            sx={{ position: "absolute", right: 8, top: 8, color: "#000" }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {popupItems.length > 0 ? (
            <ul>
              {popupItems.map((name, idx) => (
                <li key={idx}>{name}</li>
              ))}
            </ul>
          ) : (
            <Box>No {popupType === "product" ? "products" : "categories"} found</Box>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    offers: state?.offer?.offers,
    products: state?.product?.products,
    categories: state?.category?.categories
  };
};

export default connect(mapStateToProps, null)(InActiveOffer);
